const accordionContainer = document.querySelector('.b2b-product__list');
const sortSection = document.querySelector('.b2b-product__action-area-right');
const categorySection = document.querySelector('.b2b-product__action-area-left');

const populateAccordion = (data) => {
  accordionContainer.innerHTML = data;
  toggleLoader(false);
};

const toggleRadioChecked = (section, radio = null) => {
  const inputElements = section.querySelectorAll('input[type="radio"]');
  inputElements.forEach((input) => {
    if (input.checked) {
      input.removeAttribute('checked');
    }
  });
  if (radio) {
    radio.setAttribute('checked', 'checked');
  }
};

if (sortSection) {
  const sortButtons = sortSection.querySelectorAll('label');
  sortButtons.forEach((sortButton) => {
    sortButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      toggleLoader(true);

      toggleRadioChecked(sortSection, ev.target.parentElement.querySelector('input'));

      let categoryId = 0;
      const dropdownList = categorySection.querySelector('.dropdown__list');
      const inputElements = dropdownList.querySelectorAll('input[type="radio"]');
      inputElements.forEach((input) => {
        if (input.checked) {
          categoryId = parseInt(input.id.replace(/\D/g, ''), 10);
        }
      });

      const formDataInput = new FormData();
      formDataInput.append('action', 'b2BProductsSort');
      formDataInput.append('id', localData.id);
      formDataInput.append('category', categoryId);
      formDataInput.append('sortby', ev.target.dataset.sortby);
      formDataInput.append('sort', ev.target.dataset.sort);
      axios
        .post(localData.siteURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            populateAccordion(response.data.data.html);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  });
}

if (categorySection) {
  const categoryButtons = categorySection.querySelectorAll('.dropdown__list-item');
  categoryButtons.forEach((categoryButton) => {
    categoryButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      toggleLoader(true);

      const selectedInput = ev.target.parentElement.querySelector('input');
      toggleRadioChecked(categorySection, selectedInput);
      toggleRadioChecked(sortSection);
      sortSection.querySelector('.dropdown__placeholder-text').innerHTML = 'Sortiraj';

      const formDataInput = new FormData();
      formDataInput.append('action', 'b2BProductsCategory');
      formDataInput.append('id', localData.id);
      formDataInput.append('category', parseInt(selectedInput.id.replace(/\D/g, ''), 10));
      axios
        .post(localData.siteURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            populateAccordion(response.data.data.html);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  });
}
